import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    addCorrectionSuccess: '',
    getCorrectionLogSuccess: {}
}

const CorrectionReducer = (state = initState, { type, payload }) => {

    switch (type) {
        case CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.ADD_COORECTION_API_CALL_SUCCESS:
            return {
                ...state,
                addCorrectionSuccess: payload.value
            }

        case CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.GET_CORRECTION_LOG_API_CALL_SUCCESS:
            return {
                ...state,
                getCorrectionLogSuccess: payload.value
            }

        default:
            return state
    }
}

export default CorrectionReducer;
